import { render, staticRenderFns } from "./Game.html?vue&type=template&id=5d5e1743&scoped=true&external"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"
import style0 from "./Game.scss?vue&type=style&index=0&id=5d5e1743&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5e1743",
  null
  
)

export default component.exports